import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./setUpProject.css";
import { Submit } from "../../Components/Button";
import Select from "react-select";
import axios from "axios";
import { motion } from "framer-motion";
import swal from "sweetalert";
import { addNewColumn, getNewColumns } from "../../services/api/apiHandler";
import makeAnimated from "react-select/animated";


import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css";
import { Button } from "../../myfin_v2/elements/Button";
import { ReactComponent as UploadIcon } from "../../myfin_v2/assets/icons/upload.svg";
import Modal from "../../myfin_v2/elements/Modal";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as ExcelIcon } from "../../myfin_v2/assets/icons/excel.svg";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as CheckIcon } from "../../myfin_v2/assets/icons/circle_check.svg";
import { ReqFieldLabel } from "../../myfin_v2/components/mis";
import CustomDropdownIndicator from "../../myfin_v2/elements/CustomDropdownIndicator";
import { customStyles } from "../../Bookclosure/Components/AddTaskModal"

const ForgotPwd = (props) => {
  const project_id = localStorage.getItem("project_id");
  const animatedComponents = makeAnimated();

  const [show, setShow] = useState(false);
  const [Name, setName] = useState({
    ledger_code: "",
    cy: "",
    ledger_name: "",
    py: "",
    tcomparative: "", 
    tbAmount: "",
  });
  const [temp, setTemp] = useState([]);
  const [info, setInfo] = useState([]);
  const [valid, setValid] = useState(true);
  const [option, setOption] = useState([]);
  const [ledgerNameOption, setLedgerNameOption] = useState([]);
  const [currentOption, setCurrentOption] = useState([]);
  const [previousOption, setPreviousOption] = useState([]);
  const [newcolumn, serNewColumn] = useState(false);
  const [columnname, setColumnName] = useState({
    newColumnName: "",
    columns: [],
  });

  // const [options, setOptions] = useState([])
  const i = props.index;
  const fileData = props.projectData;
  let header = props.headers;

  const units = [
    { value: "Whole Numbers", label: "Whole Numbers" },
    // { value: 'Tens', label: 'Tens' },
    { value: "Hundreds", label: "Hundreds" },
    { value: "Thousands", label: "Thousands" },
    { value: "Lakhs", label: "Lakhs" },
    { value: "Crores", label: "Crores" },
  ];

  useEffect(() => {
    setOption([]);
    header.map((val) => {
      // setOption(...option,{ 'value': val , 'label':             val })
      setOption((option) => [...option, { value: val, label: val }]);
      // setOptions(options => [...options,{ 'value': val ,'label': val }])
    });
    getNewColumnUpdate();
  }, []);

  const handleSelect = (field, e) => {
    setName({ ...Name, [field]: e.value });
    if (field === "ledger_code") {
      const res = option.filter((line) => {
        if (!(line.value === e.value)) {
          return line;
        }
      });
      setLedgerNameOption(res);
      // setCurrentOption([])
    } else if (field === "ledger_name") {
      const res = ledgerNameOption.filter((line) => {
        if (!(line.value === e.value)) {
          return line;
        }
      });
      setCurrentOption(res);
      // setPreviousOption([])
    } else if (field === "cy") {
      const res = currentOption.filter((line) => {
        if (!(line.value === e.value)) {
          return line;
        }
      });
      setPreviousOption(res);
    }
  };

  // function handleValid() {
  //   let arr = Object.values(Name);
  //   const obj = arr;

  //   if (Name.ledger_code === "" && Name.ledger_name === "") {
  //     setValid(false);
  //     return;
  //   } else if (Name.ledger_code === "" || Name.ledger_name === "") {
  //     setValid(true);
  //   }

  //   if (Name.cy === "" || Name.py === "") {
  //     setValid(false);
  //   } else {
  //     setValid(true);
  //   }

  //   if (!Name.tbAmount) {
  //     setValid(false);
  //   } else {
  //     setValid(true);
  //   }

  // }

  function handleValid() {
  if (
    !Name.ledger_code ||
    !Name.ledger_name ||
    !Name.cy ||
    !Name.py ||
    !Name.tbAmount
  ) {
    setValid(false);
  } else {
    setValid(true);
  }
}


  useEffect(() => {
    let obj = Object.values(Name);
    let headers = header.filter((item) => !obj.includes(item));
    setTemp(headers);
    handleValid();
  }, [Name]);

  function handleSubmit() {
    if (valid) {
      let obj = Object.values(Name);

      const auth = localStorage.getItem("auth_token");
      const project_id = localStorage.getItem("project_id");
      const temp_id = fileData[0].data.tmp_id;

      let headers = {
        "x-auth-token": auth,
        // 'Content-Type' : 'application/json'
      };

      axios
        .post(
          `/api/v1/tb-mapping/heading-classification/${project_id}/${temp_id}`,
          Name,
          { headers }
        )
        .then((response) => {
          const validation = [...props.confirm];
          validation[i] = true;
          props.setConfirm(validation);
          setOption(null);
          setShow(false);
          props.setShow(false);
        })
        .catch((error) => {
        });
    } else {
      swal("", "please enter the mandatory fields", "warning");
    }
  }

  const handleNewColumnUpdate = () => {
    if (columnname.newColumnName === "") {
      swal("", "Please enter column name.", "warning");
      return;
    }

    addNewColumn(project_id, {
      column_name: columnname.newColumnName,
    }).then((response) => {
      if (response.status === 200) {
        serNewColumn(false);
        getNewColumnUpdate();
        swal("", response.data.message, "success");
      }
    }).catch((error) => {
      swal("", error.response.data.error, "error");
    });
  };

  const getNewColumnUpdate = () => {
    getNewColumns(project_id).then((response) => {
      if (response.status === 200) {
        setColumnName({
          ...columnname,
          columns: response.data?.column?.column,
          newColumnName: "",
        });
      }
    }).catch((error) => {
      swal("", error.response.data.error, "error");
    });
  };

  useEffect(() => {
    setShow(props.show);
    setInfo(props.info);
  }, [props.show]);

 const alignedStyles = {
  ...customStyles,
  control: (provided, state) => ({
    ...(customStyles.control ? customStyles.control(provided, state) : provided),
    minHeight: "38px",
    backgroundColor: "#f4faf5",
  }),
  dropdownIndicator: (provided, state) => ({
    ...(customStyles.dropdownIndicator ? customStyles.dropdownIndicator(provided, state) : provided),
    marginTop: "0px", // Shifting it down from the inherited -3px
  }),
  valueContainer: (provided) => ({
    ...(customStyles.valueContainer ? customStyles.valueContainer(provided) : provided),
    justifyContent: "flex-start",
    alignItems: "center",
    textAlign: "left",
    padding: "0 12px",
  }),
  input: (provided) => ({
    ...(customStyles.input ? customStyles.input(provided) : provided),
    margin: 0,
    padding: 0,
    color: "#33584e",
    textAlign: "left",
  }),
  singleValue: (provided) => ({
    ...(customStyles.singleValue ? customStyles.singleValue(provided) : provided),
    color: "#33584e",
    textAlign: "left",
    margin: 0,
    top: "50%",
    transform: "translateY(-50%)",
  }),
  placeholder: (provided) => ({
    ...(customStyles.placeholder ? customStyles.placeholder(provided) : provided),
    textAlign: "left",
    color: "#b3c0bd",
    margin: 0,
  }),
  option: (provided, state) => ({
    ...(customStyles.option ? customStyles.option(provided, state) : provided),
    backgroundColor: state.isFocused || state.isSelected ? "#f4faf5" : "#fff",
    color: "#33584e",
    textAlign: "left",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 99999,
  }),
  menu: (provided) => ({
    ...(customStyles.menu ? customStyles.menu(provided) : provided),
    zIndex: 99999,
  }),
  menuList: (provided) => ({
    ...(customStyles.menuList ? customStyles.menuList(provided) : provided),
    overflowY: "auto",
  }),
};

  return (
    <>
      {show && (

        <Modal
          width="40%"
          title="Map Column headers"
          bodycss={commoncss.unsetPadding}
          bodyStyle={{ overflow: "visible" }}
          headerActions={
            <>
              <span className={`${commoncss.clickable} ${commoncss.labelAddclm} ${commoncss.fs15} ${commoncss.textLabel} mr-2 `}
                onClick={() => {
                  // handleNewInput();
                  serNewColumn(!newcolumn);
                }}><PlusIcon /> Add column</span>
              <CloseIcon
                onClick={() => {
                  setShow(false);
                  props.setShow(false);
                }}
                className="clickable"
              />
            </>
          }
          // onClose={TBModalCleanUp}
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={() => {
                  setShow(false);
                  props.setShow(false);
                }}
                label="Cancel"
              />
              <Button
                btnColor={buttoncss.primary}
                label="Finish"
                onClick={handleSubmit}
              />
            </>
          }
        >
          <div className="container" style={{ overflow: "visible" }}>
            <div className="row mb-1 mt-3">
              <div className="col-md-6">
                <span className="input-label">Name of the Branch</span>
                <Select
                  placeholder="Select branch"
                  as="select"
                  options={option}
                  className={`w-100 mt-1 mb-2`}
                  classNamePrefix="select"
                  components={{
                    ...animatedComponents,
                    IndicatorSeparator: () => null,
                    DropdownIndicator: CustomDropdownIndicator,
                  }}
                  closeMenuOnSelect={true}
                  styles={alignedStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="col-md-6">
                <span className="input-label"><ReqFieldLabel />&nbsp;Ledger code</span>
                <Select
                  placeholder="Select ledger code"
                  as="select"
                  options={option}
                  onChange={(e) => {
                    handleSelect("ledger_code", e);
                  }}
                  className={`w-100 mt-1 mb-2`}
                  classNamePrefix="select"
                  components={{
                    ...animatedComponents,
                    IndicatorSeparator: () => null,
                    DropdownIndicator: CustomDropdownIndicator,
                  }}
                  closeMenuOnSelect={true}
                  styles={alignedStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-md-6">
                <span className="input-label"><ReqFieldLabel />&nbsp;Ledger Name</span>
                <Select
                  placeholder="Select ledger name"
                  as="select"
                  options={option}
                  onChange={(e) => {
                    handleSelect("ledger_name", e);
                  }}
                  className={`w-100 mt-1 mb-2`}
                  classNamePrefix="select"
                  components={{
                    ...animatedComponents,
                    IndicatorSeparator: () => null,
                    DropdownIndicator: CustomDropdownIndicator,
                  }}
                  closeMenuOnSelect={true}
                  styles={alignedStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="col-md-6">
                <span className="input-label"><ReqFieldLabel />&nbsp;Current year Net Balance Column</span>
                <Select
                  placeholder="Select Current year"
                  as="select"
                  options={option}
                  onChange={(e) => {
                    handleSelect("cy", e);
                  }}
                  className={`w-100 mt-1 mb-2`}
                  classNamePrefix="select"
                  components={{
                    ...animatedComponents,
                    IndicatorSeparator: () => null,
                    DropdownIndicator: CustomDropdownIndicator,
                  }}
                  closeMenuOnSelect={true}
                  styles={alignedStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-md-6">
                <span className="input-label"><ReqFieldLabel />&nbsp;Previous year Net Balance Column</span>
                <Select
                  placeholder="Select Previous Year"
                  as="select"
                  options={option}
                  onChange={(e) => {
                    handleSelect("py", e);
                  }}
                  className={`w-100 mt-1 mb-2`}
                  classNamePrefix="select"
                  components={{
                    ...animatedComponents,
                    IndicatorSeparator: () => null,
                    DropdownIndicator: CustomDropdownIndicator,
                  }}
                  closeMenuOnSelect={true}
                  styles={alignedStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="col-md-6">
                <span className="input-label"><ReqFieldLabel />&nbsp;Amount in Trial Balance</span>
                <Select
                  placeholder="Select amount"
                  as="select"
                  options={units}
                  onChange={(e) => {
                    handleSelect("tbAmount", e);
                  }}
                  className={`w-100 mt-1 mb-2`}
                  classNamePrefix="select"
                  components={{
                    ...animatedComponents,
                    IndicatorSeparator: () => null,
                    DropdownIndicator: CustomDropdownIndicator,
                  }}
                  closeMenuOnSelect={true}
                  styles={alignedStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>

          
            <div className="row mb-3">
              {columnname.columns &&
                columnname.columns.length > 0 &&
                columnname.columns.map((columnName, i) => (
                  <div className="col-md-6" key={i}>
                    <span className="input-label">{columnName?.Header && columnName.Header}</span>
                    <Select
                      placeholder="Select Column"
                      as="select"
                      // options={previousOption}
                      options={option}
                      onChange={(e) => {
                        handleSelect(
                          columnName?.accessor && columnName.accessor,
                          e
                        );
                      }}
                      className={`w-100 mt-1 mb-2`}
                      classNamePrefix="select"
                      components={{
                        ...animatedComponents,
                        IndicatorSeparator: () => null,
                        DropdownIndicator: CustomDropdownIndicator,
                      }}
                      closeMenuOnSelect={true}
                      styles={alignedStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>
                ))}
            </div>
            <div className="d-flex mb-3" style={{ width: "23rem" }}>
              {newcolumn && (
                <>
                  <div className={`${commoncss.inputCol}`} >
                    <input
                      // style={{ width: "100px" }}
                      type="text"
                      placeholder="Enter Column Name"
                      value={columnname.newColumnName}
                      onChange={(e) => {
                        setColumnName({
                          ...columnname,
                          newColumnName: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <Button
                    icon={<CheckIcon width={18} height={18} />}
                    btnColor={buttoncss.secondary}
                    class_={`ml-2`}
                    
                    onClick={handleNewColumnUpdate}
                    label={"Save"}
                  />
                </>
              )}
            </div>

             <div className="row mb-1"style={{ marginTop: "-16px" }}>
              <div className="col-md-6">
                <span className="input-label">Comparative (Extra)</span>
                <Select
                  options={option}
                  onChange={(e) => {
                    handleSelect("tcomparative", e);
                  }}
                  className="w-100 mt-1 mb-2"
                  classNamePrefix="select"
                  components={{
                    ...animatedComponents,
                    IndicatorSeparator: () => null,
                    DropdownIndicator: CustomDropdownIndicator,
                  }}
                  closeMenuOnSelect={true}
                  styles={alignedStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>

          </div>
        </Modal>
      )}

    </>
  );
};

export default ForgotPwd;

const SelectMenu = ({ data, name, value, onChange }) => {
  return (
    <>
      <Select
        labelId="demo-simple-select-standard-label"
        id="demo-simple-select-standard"
        className="w-100"
        name={name}
        value={value}
        onChange={onChange}
        displayEmpty
        sx={{
          backgroundColor: "#f4faf5",
          border: "1px solid #c2e6d1",
          borderRadius: "10px",
          color: "#4d6d64",
          "& .MuiSelect-select": {
            padding: "8px 10px",
            color: "#4d6d64",
          },
          "& .MuiSelect-icon": {
            color: "#4d6d64",
          },
          "& fieldset": {
            border: "none",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "#f4faf5",
            },
          },
        }}
      >
        <MenuItem value={"select"} disabled sx={{ color: "#4d6d64" }}>
          {`Select ${name}`}
        </MenuItem>
        {data &&
          data.length > 0 &&
          data.map((ele, ix) => (
            <MenuItem key={ix} value={ele} sx={{ color: "#4d6d64" }}>
              {ele}
            </MenuItem>
          ))}
      </Select>
    </>
  );
};

